import React, { useCallback, useMemo } from 'react';
import { DataGridProps, ToolbarPropsOverrides } from '@mui/x-data-grid';
import { DiamDataGridToolbar } from './DiamDataGridToolbar';
import { StyledDataGrid } from './styles';
import { DiamDataGridTabs } from './types';

interface DiamDataGridProps
  extends Omit<DataGridProps, 'showToolbar' | 'slots'> {
  title?: string;
  searchPlaceholder?: string;
  tabs?: DiamDataGridTabs;
}

const SERVER_FILTER_PANEL_SLOT_PROPS: NonNullable<DataGridProps['slotProps']> =
  {
    filterPanel: {
      filterFormProps: {
        operatorInputProps: {
          sx: { display: 'none' },
        },
      },
    },
  };

function mergeSlotProps(
  slotProps: DataGridProps['slotProps'],
): DataGridProps['slotProps'] {
  if (!slotProps) {
    return SERVER_FILTER_PANEL_SLOT_PROPS;
  }

  return {
    ...slotProps,
    filterPanel: {
      ...SERVER_FILTER_PANEL_SLOT_PROPS.filterPanel,
      ...slotProps.filterPanel,
      filterFormProps: {
        ...SERVER_FILTER_PANEL_SLOT_PROPS.filterPanel?.filterFormProps,
        ...slotProps.filterPanel?.filterFormProps,
        operatorInputProps: {
          ...SERVER_FILTER_PANEL_SLOT_PROPS.filterPanel?.filterFormProps
            ?.operatorInputProps,
          ...slotProps.filterPanel?.filterFormProps?.operatorInputProps,
        },
      },
    },
  };
}

export function DiamDataGrid({
  title,
  searchPlaceholder,
  tabs,
  slotProps,
  ...dataGridProps
}: DiamDataGridProps) {
  const mergedSlotProps = useMemo(() => mergeSlotProps(slotProps), [slotProps]);

  const renderToolbar = useCallback(
    (props: ToolbarPropsOverrides) => (
      <DiamDataGridToolbar
        {...props}
        title={title}
        searchPlaceholder={searchPlaceholder}
        tabs={tabs}
      />
    ),
    [title, searchPlaceholder, tabs],
  );

  return (
    <StyledDataGrid
      {...dataGridProps}
      slotProps={mergedSlotProps}
      disableColumnMenu
      slots={{ toolbar: renderToolbar }}
      showToolbar
    />
  );
}
